import { ComponentSingleStyleConfig } from "@chakra-ui/react";

export const tableTheme: ComponentSingleStyleConfig = {
  baseStyle: {
    th: {
      textTransform: "none",
    },
  },
};
